import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Listing from "./listing"
import { getDataFaqs, getFaqbyId, deleteFaq, updateFaqStatus } from "../../services/faq/action"
import { SearchBar } from "./SearchBar"
import AddUpdateFaq from "./addUpdateFaq"
import DeleteModal from "../../common/deleteModal"
import { getPrivileges } from '../../common/adminPrivilege';
import { getAdminPaginationLimit } from "../../../common/common"

const FaqIndex = () => {
    const [faqData, setFaqData] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const limit = getAdminPaginationLimit();
    const dispatch = useDispatch()
    const [formshow, setFormShow] = useState(false);
    const [deleteshow, setDeleteShow] = useState(false);
    const [deleteid, setDeleteId] = useState(null)
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const { faqs, totalCount } = useSelector((state) => state.faq)
    const loading = useSelector((state) => state.faq.loading)
    const error = useSelector((state) => state.faq.error)
    const requestBody = {
        page: currentPage,
        limit: limit,
        keyword: "",
    };
    const [filterdata, setFilterData] = useState(requestBody);
    const getPrivilege = getPrivileges();
    const editFaq = getPrivilege.canEditFaq();

    useEffect(() => {
        dispatch(getDataFaqs(requestBody))
    }, []);

    const handleFormShow = async (id) => {
        try {
            if (typeof id === "number") {
                const response = await getFaqbyId(id);
                const result = response.data
                setFaqData(result);                
            }
        } catch (error) { }
        setFormShow(true);
    }

    const handleFormClose = () => {
        setFormShow(false);
        setFaqData('')
    }

    const deleteModalOpen = (id) => {
        setDeleteShow(true);
        setDeleteId(id)
    }
    const handleDeleteClose = () => {
        setDeleteShow(false);
    }

    const setOrderIdArray = () => {
        const checkedInputs = document.querySelectorAll("input[name='order_id_faq[]']:checked");
        const newOrderIds = Array.from(checkedInputs, input => input.value);
        return newOrderIds
    }
    const handleDelete = async () => {
        try {
            let id;
            if (typeof deleteid === "number") {
                id = [deleteid];
            } else {
                id = setOrderIdArray();
            }
            const data = { id };
            await deleteFaq(data)
            let updatedFilterData = requestBody;
            if(faqs.length <= 1 && currentPage > 1){
                updatedFilterData = {
                    ...filterdata,
                    page: currentPage - 1,
                };
                setCurrentPage(currentPage - 1);
                setFilterData(updatedFilterData);
            }
            dispatch(getDataFaqs(updatedFilterData))
            handleDeleteClose();
        } catch (error) { }
    };

    const handleSelectedStatusUpdate = async (status) => {
        const data = {
            "id": setOrderIdArray(),
            "status": status
        }
        try {
            const response = await updateFaqStatus(data)
            if (response === true) {
                dispatch(getDataFaqs(requestBody))
            }
        } catch (error) {
        }
    }

    const handleStatus = async (e, id, status) => {
        let faq_id = [id]
        const newStatus = status === 1 ? 0 : 1;
        faqs.map((faq) => {
            if (faq.faq_id === id) {
                faq.faq_status = newStatus;
            }
            return faq;
        });
        const data = {
            "status": newStatus,
            "id": [id],
        }
        try {
            await updateFaqStatus(data)
            dispatch(getDataFaqs(requestBody))
        } catch (error) {
        }
    };

    const handleFilterUpdate = async (name, value, boolen) => {
        let updatedFilterData;
        updatedFilterData = {
            ...filterdata,
            [name]: value,
        };
        setFilterData(updatedFilterData);
        if (boolen === true) {
            dispatch(getDataFaqs(updatedFilterData))
        }
    };

    const handleFilter = () => {
        let updatedFilterData = {
            ...filterdata,
            page: 1,
        }
        setCurrentPage(1)
        dispatch(getDataFaqs(updatedFilterData))
    }

    const handleClear = () => {
        setFilterData(requestBody);
        dispatch(getDataFaqs(requestBody))
    }

    const handlePaginate = (selectedPage) => {
        const updatedFilterData = {
            ...filterdata,
            page: selectedPage.selected + 1,
        };
        setCurrentPage(selectedPage.selected + 1);
        setFilterData(updatedFilterData);
        dispatch(getDataFaqs(updatedFilterData))
    };

    const calculateSerialNumber = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    const handleCheckboxChange = (event, labelId) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            setSelectedCheckboxes((prevSelected) => [...prevSelected, labelId]);
        } else {
            setSelectedCheckboxes((prevSelected) =>
                prevSelected.filter((id) => id !== labelId)
            );
        }
    };

    return (
        <>
            <div className="bg-whites mt-4 pt-5">
                <div className="container-fluid inner-section">

                    <SearchBar
                        handleFormShow={handleFormShow}
                        selectedCheckboxes={selectedCheckboxes}
                        deleteModalOpen={deleteModalOpen}
                        handleFilterUpdate={handleFilterUpdate}
                        handleSelectedStatusUpdate={handleSelectedStatusUpdate}
                        handleFilter={handleFilter}
                        filterdata={filterdata}
                        handleClear={handleClear}
                        editFaq={editFaq}
                    />

                    <Listing
                        faqs={faqs}
                        totalCount={totalCount}
                        loading={loading}
                        error={error}
                        limit={limit}
                        handlePaginate={handlePaginate}
                        handleFormShow={handleFormShow}
                        calculateSerialNumber={calculateSerialNumber}
                        deleteModalOpen={deleteModalOpen}
                        handleCheckboxChange={handleCheckboxChange}
                        setSelectedCheckboxes={setSelectedCheckboxes}
                        handleStatus={handleStatus}
                        editFaq={editFaq}
                        currentPage={currentPage}
                    />
                </div>
            </div>

            {formshow &&
                <AddUpdateFaq
                    formshow={formshow}
                    handleFormClose={handleFormClose}
                    editFaq={editFaq}
                    faqData={faqData} />
            }
            <DeleteModal
                show={deleteshow}
                deleteModalOpen={deleteModalOpen}
                handleDeleteClose={handleDeleteClose}
                handleDelete={handleDelete}
            />
        </>
    )
}


export default FaqIndex